import api from '../api'
import auth from '../token'

const station = auth.getStationNumber();

export default {

  getBackupTask (page = 0, word = '', idStation = null, size = 5) {
    const role = localStorage.getItem('role');

    if (role === 'ADMIN' || role === 'SUPPORT') {
      if (!idStation || idStation === null) {
        return api.request('GET', '/backupTask/list?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
      } else {
        return api.request('GET', '/backupTask/list/' + idStation.station + '?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
      }
    } else {
      return api.request('GET', '/backupTask/list/' + station + '?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
    }
  },
  create(form) {
    return api.request('POST', '/backupTask/create', form);
  },
  delete(id) {
    return api.request('DELETE', '/backupTask/delete/' + id);
  },
  getByID(id){
    return api.request('GET', '/backupTask/' + id);
  },
  update(id, form){
    return api.request('PUT', '/backupTask/update/' + id, form);
  }

}
